// MASANDI OS — centralized UI dictionaries. Add a key once here; pages never hardcode copy.
// System field names / statuses stay English by design (they are data, not copy).

export const DICT = {
  id: {
    // ---- navigation & shell ----
    "nav.home": "Beranda", "nav.projects": "Proyek", "nav.missions": "Misi", "nav.workflows": "Alur Kerja",
    "nav.approvals": "Persetujuan", "nav.workforce": "Tim AI", "nav.knowledge": "Pengetahuan", "nav.assets": "Aset",
    "nav.decisions": "Keputusan", "nav.analytics": "Analitik", "nav.activity": "Aktivitas", "nav.jobs": "Pusat Job",
    "nav.productionTools": "Alat Produksi", "nav.settings": "Pengaturan",

    "layout.commandPlaceholder": "Tanya atau instruksikan MASANDI OS…  mis. 'Buat content plan LURI SALA 7 hari'",
    "layout.execute": "Jalankan", "layout.running": "Memproses…",
    "layout.toastCmdFailed": "Perintah gagal.",
    "layout.toastStillRunning": "Masih berjalan — periksa halaman Misi sebentar lagi.",
    "layout.toastMission": "Misi terkelola dieksekusi — menunggu persetujuan Anda.",
    "layout.toastStatus": "Status terstruktur disusun dari data terkini.",
    "layout.toastCross": "CROSS_PROJECT_BLOCK — otorisasi diperlukan.",
    "layout.toastReceived": "Perintah diterima.",
    "layout.toastCmdFailedRetry": "Perintah gagal. Silakan coba lagi.",
    "layout.orchestratorResponse": "Respons Orchestrator",
    "layout.classified": "TERKLASIFIKASI", "layout.project": "PROYEK",
    "layout.resolution": "Resolusi: {v}",
    "layout.assembledTeam": "Tim Misi yang Disusun",
    "layout.openMissionReview": "Buka Misi & Tinjau",
    "layout.reviewAuthRequest": "Tinjau Permintaan Otorisasi",
    "layout.noDataAccessed": "Tidak ada data yang diakses.",
    "layout.showTest": "Tampilkan data TEST/QA", "layout.hideTest": "Sembunyikan data TEST/QA",
    "layout.testBannerLead": "DATA TEST/QA TERLIHAT",
    "layout.testBannerRest": " — artefak engineering/test ditampilkan untuk debugging. Beranda, Analitik, CEO Brief, dan konteks produksi AI selalu mengabaikan data test.",
    "layout.sgHealth": "Kesehatan", "layout.sgStage": "Tahap", "layout.sgActiveMissions": "Misi Aktif",
    "layout.sgPendingApprovals": "Persetujuan Tertunda", "layout.sgCurrentCost": "Biaya Saat Ini",
    "layout.sgNextMilestone": "Milestone Berikutnya", "layout.sgMainBlocker": "Hambatan Utama",
    "layout.sgNextAction": "Aksi Berikutnya",

    "gate.confirmCta": "Buka Migration Gate Sekarang",
    "gate.confirming": "Membuka gate…",
    "gate.openedTitle": "P001 Migration Gate: OPEN",
    "gate.openedNote": "Import belum berjalan otomatis.",
    "gate.startCta": "Mulai Migrasi P001",
    "gate.blockedTitle": "MIGRATION GATE BLOCKED",
    "gate.blockedNote": "Gate tidak dibuka. Blocker yang belum selesai:",
    "gate.readiness": "Readiness",
    "gate.toastConfirm": "Konfirmasi Founder diperlukan untuk membuka gate.",
    "gate.toastOpened": "P001 Migration Gate dibuka. Import belum berjalan.",
    "gate.toastBlocked": "Migration gate diblokir — lihat blocker.",
    "gate.toastStaged": "Migrasi disiapkan (staged) — import belum berjalan.",

    "cmp.templates": "Template Perintah",
    "cmp.suggestions": "Saran",
    "gate.batchReady": "Inventory Batch 1 disiapkan — import tidak dijalankan.",
    "ws.tabMigration": "Migrasi",
    "mig.empty": "Belum ada batch migrasi. Siapkan via command: 'Siapkan Batch 1 Migrasi P001 LURI SALA — Brand & Governance Canonical'.",
    "mig.note": "Mengisi atau menyetujui item TIDAK menjalankan import. Promosi ke PRODUCTION hanya melalui batch processing + approval Founder.",
    "mig.blockers": "Blocker migrasi",
    "mig.provenance": "Kelengkapan provenance",
    "mig.canonical": "Input kanonik",
    "mig.source": "Sumber",
    "mig.sourceType": "Tipe sumber",
    "mig.sourceUrl": "URL / link asset sumber",
    "mig.version": "Versi",
    "mig.originalDate": "Tanggal asli (YYYY-MM-DD)",
    "mig.approvalState": "Approval state",
    "mig.lockState": "Lock state",
    "mig.supersedes": "Supersedes",
    "mig.rejectedReason": "Alasan rejected",
    "mig.target": "Target collection",
    "mig.saveInput": "Simpan Input",
    "mig.reviewed": "Tandai REVIEWED",
    "mig.approve": "Approve for Migration",
    "mig.reject": "Reject",
    "mig.rejectReason": "Alasan reject (wajib)",
    "mig.history": "Riwayat perubahan",
    "mig.saved": "Perubahan item migrasi tersimpan.",
    "mig.mainBlocker": "Blocker utama",
    "mig.remaining": "item masih harus diselesaikan sebelum batch dapat diproses",
    "mig.none": "Tidak ada",
    "home.migrationReady": "Batch {n} Migrasi {code} siap diproses",
    "home.openMigration": "Buka Migrasi",
    "cmp.expand": "Perbesar editor",
    "cmp.collapse": "Perkecil",
    "cmp.pickerTitle": "Template Perintah",
    "cmp.pickerHint": "Pilih template untuk mengisi composer — tidak langsung dijalankan.",
    "cmp.useTemplate": "Gunakan",
    "cmp.newTemplate": "Template Baru",
    "cmp.edit": "Edit",
    "cmp.duplicate": "Duplikat",
    "cmp.archive": "Arsipkan",
    "cmp.favorite": "Favorit",
    "cmp.manage": "Kelola Template",
    "cmp.allCats": "Semua",
    "cmp.scope": "Scope",
    "cmp.scopeCompany": "COMPANY",
    "cmp.scopeProject": "PROJECT",
    "cmp.category": "Kategori",
    "cmp.title": "Judul",
    "cmp.body": "Isi perintah",
    "cmp.save": "Simpan",
    "cmp.versions": "Riwayat versi",
    "cmp.versionN": "v{n}",
    "cmp.createTitle": "Buat Template",
    "cmp.editTitle": "Edit Template",
    "cmp.toastFilled": "Template dimuat ke composer — edit lalu tekan Jalankan.",
    "cmp.toastSaved": "Template disimpan.",
    "cmp.toastDup": "Template diduplikat.",
    "cmp.toastArchived": "Template diarsipkan.",
    "cmp.toastFav": "Status favorit diperbarui.",
    "cmp.needTitleBody": "Judul dan isi wajib diisi.",

    // ---- common ----
    "common.viewAll": "Lihat semua", "common.failed": "Gagal", "common.actionFailed": "Aksi gagal",
    "common.approve": "Setujui", "common.revise": "Revisi", "common.reject": "Tolak", "common.export": "Ekspor",
    "common.loading": "Memuat…", "common.noData": "Tidak ada data.",
    "common.etExecutive": "Eksekutif", "common.etLead": "Lead", "common.etSpecialist": "Spesialis", "common.etControl": "Kontrol",
    "common.retryProviderTitle": "Retry job untuk menjalankan ulang provider sebelum menyetujui.",

    // ---- login ----
    "login.title": "Akses Founder", "login.subtitle": "Sistem operasi AI-native yang terkelola.",
    "login.password": "Kata Sandi", "login.signInFailed": "Masuk gagal", "login.enter": "Masuk ke MASANDI OS",
    "login.footer": "Dikelola oleh Locks · Keputusan · Persetujuan A0–A4 · Four-Eyes",

    // ---- home ----
    "home.commandCenter": "PUSAT KOMANDO", "home.welcome": "Selamat datang, Founder.",
    "home.statGoverned": "Misi Terkelola", "home.statGovernedSub": "siklus hidup terpantau",
    "home.statDecisions": "Perlu Keputusan", "home.statDecisionsSub": "di pusat persetujuan",
    "home.statLock": "Kepatuhan Lock", "home.statLockSub": "tanpa override diam-diam",
    "home.statSpend": "Belanja AI", "home.statSpendSub": "terukur per run",
    "home.needsDecision": "Perlu Keputusan Anda",
    "home.noPending": "Tidak ada persetujuan tertunda. Tim AI siaga dalam tata kelola.",
    "home.activeMissions": "Misi Aktif",
    "home.noActiveMissions": "Belum ada misi aktif. Gunakan command bar di bawah untuk meluncurkannya.",
    "home.requestedBy": "Diminta oleh {name} · risiko {risk} · rekomendasi AI: {rec}",
    "home.workforce": "Tim AI", "home.inspect": "Lihat", "home.persistentEmployees": "karyawan AI persisten",
    "home.portfolio": "Portofolio Proyek",
    "home.recentActivity": "Aktivitas Terbaru", "home.noActivity": "Belum ada aktivitas.",

    // ---- projects ----
    "projects.label": "PORTOFOLIO PROYEK", "projects.title": "Proyek",
    "projects.subtitle": "Multi-proyek sejak hari pertama. Setiap proyek terisolasi penuh.",
    "projects.new": "Proyek Baru", "projects.createTitle": "Buat Proyek",
    "projects.phCode": "Kode proyek (mis. P002)", "projects.phName": "Nama proyek",
    "projects.phIndustry": "Industri", "projects.phObjective": "Tujuan utama",
    "projects.createSubmit": "Buat proyek terisolasi",
    "projects.codeNameRequired": "Kode dan nama wajib diisi",
    "projects.created": "Proyek {code} dibuat — terisolasi dari semua proyek lain.",
    "projects.health": "Kesehatan: {v}",

    // ---- project workspace ----
    "ws.back": "Proyek",
    "ws.requestNote": "Founder meminta perubahan pada {title}",
    "ws.requestToast": "{result} — tidak ada entitas yang ditimpa. Persetujuan override A4 dibuat.",
    "ws.tabOverview": "Ikhtisar", "ws.tabMissions": "Misi", "ws.tabTasks": "Tasks", "ws.tabDecisions": "Keputusan",
    "ws.tabAssets": "Aset", "ws.tabGovernance": "Tata Kelola", "ws.tabActivity": "Aktivitas",
    "ws.cardActiveMissions": "Misi Aktif", "ws.cardPendingApprovals": "Persetujuan Tertunda",
    "ws.cardCurrentCost": "Biaya Saat Ini", "ws.cardMainBlocker": "Hambatan Utama",
    "ws.cardNextMilestone": "Milestone Berikutnya", "ws.cardNextAction": "Aksi yang Direkomendasikan",
    "ws.overrides": "Override Proyek (khusus proyek ini)",
    "ws.noMissions": "Belum ada misi.", "ws.noTasks": "Belum ada task produksi untuk proyek ini.",
    "ws.byMaker": "oleh {v}",
    "ws.govText1": "Lock Frozen / Brand / Legal / Compliance tidak dapat diedit. Aksinya menjadi",
    "ws.govText2": "→ analisis dampak → override eksplisit Founder.",
    "ws.requestChange": "Minta Perubahan",

    // ---- missions list ----
    "missions.label": "EKSEKUSI TERKELOLA", "missions.title": "Misi",
    "missions.subtitle": "Setiap misi disusun, dieksekusi, direview (Four-Eyes), dan disetujui Founder. Luncurkan lewat command bar di bawah.",
    "missions.empty": "Belum ada misi. Coba:",

    // ---- mission detail ----
    "md.back": "Misi",
    "md.actionApprove": "disetujui", "md.actionRevise": "— revisi diminta", "md.actionReject": "ditolak",
    "md.actionToast": "Misi {v}.",
    "md.notePrefix": "{action} via tampilan Misi",
    "md.exportEmpty": "(belum ada deliverable)", "md.exported": "Deliverable diekspor.",
    "md.creatingProd": "Misi produksi sedang dibuat…", "md.prodCreated": "Misi produksi dibuat.",
    "md.prodFailed": "Misi produksi gagal dibuat.",
    "md.successCriteria": "Kriteria keberhasilan:",
    "md.approvalRequired": "Persetujuan Founder Diperlukan",
    "md.fallbackWarning": "Draf GOVERNED FALLBACK — provider tidak tersedia. Persetujuan diblokir sampai job di-retry.",
    "md.risk": "Risiko", "md.cost": "Biaya", "md.reversibility": "Reversibilitas", "md.aiRec": "Rekomendasi AI",
    "md.requestRevision": "Minta Revisi",
    "md.founderApproved": "Disetujui Founder",
    "md.createProduction": "Buat Misi Produksi", "md.approveFirstTitle": "Setujui misi ini terlebih dahulu",
    "md.finalDeliverable": "Deliverable Final Terkompilasi",
    "md.noDeliverable": "Belum ada deliverable yang dikompilasi.",
    "md.strategy": "RINGKASAN STRATEGI", "md.audience": "TARGET AUDIENS",
    "md.objectives": "TUJUAN KONTEN", "md.pillars": "PILAR KONTEN", "md.channelMix": "CAMPURAN PLATFORM / KANAL",
    "md.calendar": "KALENDER KONTEN {days} HARI",
    "md.thDay": "Hari", "md.thTopic": "Topik", "md.thFormat": "Format", "md.thHook": "Hook",
    "md.thKeyMessage": "Pesan Kunci", "md.thCta": "CTA", "md.thProdNotes": "Catatan Produksi", "md.thRole": "Peran",
    "md.complianceNotes": "CATATAN REVIEW BRAND / COMPLIANCE",
    "md.generatedAssets": "Aset Hasil Generate · output tool nyata",
    "md.assetBy": "oleh {a} · {m}",
    "md.assetToolLine": "tool {t} · {p} · biaya ${c}",
    "md.draftNote": "Aset dimulai sebagai DRAFT dan memerlukan persetujuan Founder sebelum dirilis. Provenans (agent · tool · provider · model · biaya) tercatat di setiap aset.",
    "md.toolRuns": "Tool Runs · eksekusi terkelola",
    "md.toolRunLine": "agent {a} · biaya ${c}",
    "md.team": "Tim Misi · dipilih berdasarkan data skill",
    "md.tasks": "Eksekusi Task & Output",
    "md.reviews": "Hasil Review (Four-Eyes)", "md.noReviews": "Belum ada task review.",
    "md.finalAsset": "Aset Final / Hasil",
    "md.costAudit": "Biaya & Audit · Transisi Status",
    "md.totalCost": "Total biaya misi:",

    // ---- approvals ----
    "ap.label": "TATA KELOLA · A0–A4", "ap.title": "Pusat Persetujuan",
    "ap.subtitle": "Otoritas Founder. Item A4 memerlukan konfirmasi override eksplisit.",
    "ap.notePrefix": "{action} via Pusat Persetujuan",
    "ap.recorded": "{action} tercatat{suffix}.", "ap.overrideSuffix": " — override dikonfirmasi",
    "ap.revokeToast": "Akses {from} → {to} dicabut — referensi berikutnya diblokir kembali.",
    "ap.revokeFailed": "Pencabutan gagal",
    "ap.activeGrants": "Akses Lintas-Proyek Aktif",
    "ap.grantsDesc": "Akses baca ke pengetahuan ter-approve proyek lain. Cabut untuk segera memblokir referensi lintas-proyek berikutnya.",
    "ap.defaultReason": "Akses pengetahuan lintas-proyek",
    "ap.expirySet": "Kedaluwarsa {d}", "ap.noExpiry": "Tanpa kedaluwarsa",
    "ap.revoke": "Cabut", "ap.history": "Riwayat Akses Lintas-Proyek",
    "ap.tabAll": "SEMUA", "ap.empty": "Tidak ada persetujuan pada tampilan ini.",
    "ap.requestedBy": "Diminta oleh {v}",
    "ap.fallbackWarning": "Draf GOVERNED FALLBACK — provider tidak tersedia saat eksekusi. Persetujuan diblokir sampai Anda me-retry job untuk menjalankan ulang provider.",
    "ap.risk": "Risiko", "ap.cost": "Biaya", "ap.reversible": "Reversibilitas", "ap.aiRec": "Rekomendasi AI",
    "ap.expiryPlaceholder": "Kedaluwarsa (hari, opsional)",
    "ap.confirmOverride": "Konfirmasi Override", "ap.openMission": "Buka Misi",

    // ---- job center ----
    "jobs.label": "RUNTIME TERPADU · COMMAND · MISSION · WORKFLOW · TASK", "jobs.title": "Pusat Job",
    "jobs.subtitle": "Monitor eksekusi read-only. Tata kelola tidak dapat dilewati di sini — buka detail untuk bertindak.",
    "jobs.refresh": "Muat Ulang",
    "jobs.attention": "{n} job memerlukan perhatian Founder.",
    "jobs.empty": "Tidak ada job pada tampilan ini.",
    "jobs.cancelled": "Job dibatalkan.", "jobs.retryLaunched": "Retry diluncurkan.",
    "jobs.attentionTitle": "Perlu perhatian Founder",
    "jobs.cancel": "Batalkan", "jobs.retries": "retry {n}",

    // ---- production tools ----
    "pt.label": "SPEC-06 · GOVERNED PRODUCTION TOOL LAYER", "pt.title": "Alat Produksi",
    "pt.subtitle": "Karyawan memiliki pekerjaan · tool mengeksekusi · MASANDI OS mengendalikan routing, izin, anggaran, persetujuan, dan audit. Rahasia provider hanya di sisi server.",
    "pt.noRecords": "Tidak ada data.",
    "pt.tabRegistry": "Registri", "pt.tabProviders": "Penyedia", "pt.tabCapabilities": "Kapabilitas",
    "pt.tabPermissions": "Izin Karyawan", "pt.tabBudgets": "Anggaran", "pt.tabHealth": "Kesehatan", "pt.tabRuns": "Eksekusi",
    "pt.capabilities": "kapabilitas: {v}",
    "pt.budgetLine": "{code} — per run ${a} · per task ${b} · per misi ${c} · harian ${d} · bulanan ${e}",

    // ---- analytics ----
    "an.label": "BIAYA & KINERJA", "an.title": "Analitik",
    "an.subtitle": "Biaya dilacak per perusahaan, proyek, misi, karyawan, dan model.",
    "an.statSpend": "Total Belanja AI", "an.statRuns": "Total Run", "an.statMissions": "Misi", "an.statWorkforce": "Tim AI Aktif",
    "an.accuracy": "AKURASI BIAYA", "an.meteredRuns": "Run terukur provider:", "an.estimatedRuns": "Run estimasi:",
    "an.tokensIn": "masuk", "an.tokensOut": "keluar",
    "an.accuracyNote": "Angka terukur provider memakai penggunaan token riil yang dilaporkan model; run estimasi dibuat sebelum akuntansi terukur atau tidak memiliki laporan penggunaan.",
    "an.byProject": "Biaya per Proyek", "an.byModel": "Biaya per Model", "an.byEmployee": "Biaya per Karyawan",
    "an.noCost": "Belum ada data biaya.",

    // ---- settings ----
    "settings.title": "Pengaturan",
    "settings.tvTitle": "Visibilitas Data TEST / QA",
    "settings.tvToggleLabel": "Tampilkan data TEST / QA di layar daftar",
    "settings.tvDesc": "Preferensi utama (tersimpan lintas sesi). Default OFF. Meskipun ON, Beranda, Analitik, AI CEO Brief, kesehatan portofolio, pengambilan Knowledge, dan konteks produksi AI selalu mengecualikan data test — ini hanya memengaruhi visibilitas daftar/debug.",
    "settings.logoStatus": "Status logo:", "settings.logoNote": "dapat diganti tanpa mendesain ulang aplikasi.",
    "settings.brandHierarchy": "Hierarki Brand", "settings.projectsLine": "Proyek",
    "settings.founderAccount": "Akun Founder", "settings.name": "Nama", "settings.role": "Peran",
    "settings.invariants": "Invarian Arsitektur (permanen)",
    "settings.langTitle": "Bahasa Antarmuka",
    "settings.langDesc": "Bahasa seluruh label, tombol, dan pesan UI. Nama field/status sistem tetap Bahasa Inggris karena merupakan nilai data.",
    "settings.langId": "Indonesia", "settings.langEn": "English",

    // ---- workforce ----
    "wf.title": "Tim AI",
    "wf.count": "{n} karyawan AI persisten · karyawan idle tidak menimbulkan biaya inferensi.",
    "wf.grid": "Grid", "wf.org": "Organisasi",
    "wf.searchPh": "Cari nama, peran, atau kode…", "wf.allDepts": "Semua departemen",

    // ---- org graph / chart ----
    "org.hint": "Seret untuk menggeser · Ctrl+scroll untuk zoom · minimap untuk melompat · klik node untuk membuka",
    "org.founderSub": "Otoritas manusia",
    "org.founderSubFull": "Otoritas manusia · GO / HOLD / KILL · Override",

    // ---- agent detail ----
    "ag.back": "Tim AI", "ag.testFailed": "Uji coba gagal.",
    "ag.reportsTo": "· melapor ke {name} ({pos})", "ag.performance": "Kinerja: {v}",
    "ag.runTest": "Jalankan Tes",
    "ag.tabOverview": "Ikhtisar", "ag.tabJobdesk": "Jobdesk", "ag.tabSkills": "Keahlian", "ag.tabSop": "SOP",
    "ag.tabAuthority": "Otoritas", "ag.tabTools": "Alat", "ag.tabKpis": "KPI", "ag.tabRuns": "Eksekusi",
    "ag.missionStatement": "Pernyataan Misi", "ag.specTags": "Tag Spesialisasi",
    "ag.modelCapability": "Kapabilitas Model", "ag.knowledgeScope": "Cakupan Pengetahuan",
    "ag.coreResp": "Tanggung Jawab Inti", "ag.collabRules": "Aturan Kolaborasi", "ag.failureConds": "Kondisi Kegagalan",
    "ag.skillMatrix": "Matriks Skill (1 Awareness → 5 Expert)", "ag.sop": "Metode Operasi Standar",
    "ag.autonomy": "Tingkat Otonomi", "ag.riskCeiling": "Batas Risiko",
    "ag.allowed": "Aksi yang Diizinkan", "ag.forbidden": "Aksi yang Dilarang",
    "ag.approvalRules": "Aturan Persetujuan", "ag.escalationRules": "Aturan Eskalasi",
    "ag.toolPerms": "Izin Tool", "ag.kpis": "Indikator Kinerja Utama (KPI)",
    "ag.aiRuns": "AI Run (riwayat eksekusi terukur)",
    "ag.noRuns": "Belum ada run — karyawan idle tidak menimbulkan biaya inferensi.",
    "ag.testMode": "Mode Tes · {name}",
    "ag.testContext": "Konteks proyek P001 dimuat · aksi eksternal dinonaktifkan · model {m}.",
    "ag.instructPh": "Instruksikan {name}…", "ag.run": "Jalankan", "ag.contextUsed": "Konteks yang digunakan",

    // ---- activity / assets / decisions / knowledge ----
    "act.label": "JELAJAH AUDIT · SIAPA · APA · MENGAPA", "act.title": "Aktivitas",
    "act.subtitle": "Setiap operasi penting dapat direkonstruksi untuk audit penuh.",
    "act.empty": "Belum ada aktivitas tercatat.",
    "as.title": "Aset", "as.subtitle": "Aset → Versi → Persetujuan → Lock. Versi lama tetap dapat diakses.",
    "as.empty": "Belum ada aset.", "as.versions": "{n} versi",
    "dec.label": "LOG KEPUTUSAN", "dec.title": "Keputusan",
    "dec.subtitle": "Setiap keputusan material dicatat dengan konteks, opsi, alasan, dan pembuat keputusan.",
    "dec.rationale": "Alasan:", "dec.byMaker": "oleh {v}",
    "kn.title": "Pengetahuan",
    "kn.subtitle": "Pengetahuan yang disetujui dan tahan lama — riwayat chat tidak pernah otomatis menjadi kebenaran perusahaan.",
    "kn.empty": "Belum ada item pengetahuan.", "kn.curatedBy": "dikurasi oleh {v}",

    // ---- workflows ----
    "fl.label": "MESIN WORKFLOW REUSABLE", "fl.title": "Alur Kerja",
    "fl.subtitle": "Pipeline multi-langkah terkelola dengan percabangan CONDITION dan fork PARALLEL. Setiap langkah diarahkan ke karyawan dengan skill yang cocok.",
    "fl.new": "Workflow Baru", "fl.steps": "{n} langkah", "fl.runWf": "Jalankan Workflow",
    "fl.recentRuns": "Run Terbaru", "fl.noRuns": "Belum ada run workflow.",
    "fl.executed": "Workflow dieksekusi.", "fl.runFailed": "Eksekusi gagal",
    "fl.titleRequired": "Judul wajib diisi", "fl.stepNeedsName": "Setiap langkah memerlukan nama",
    "fl.stepNeedsSkill": "Langkah '{name}' memerlukan skill",
    "fl.created": "Workflow kustom dibuat.", "fl.saveFailed": "Gagal menyimpan",
    "fl.runDialogTitle": "Jalankan · {t}", "fl.objectivePh": "Tujuan", "fl.executeSteps": "Eksekusi langkah",
    "fl.builder": "Pembuat Workflow", "fl.wfTitlePh": "Judul workflow", "fl.wfDescPh": "Deskripsi singkat",
    "fl.stepsLabel": "Langkah-langkah (dijalankan berurutan)",
    "fl.stepNamePh": "Nama langkah", "fl.requiredSkillPh": "Skill yang dibutuhkan…",
    "fl.ifTrue": "JIKA BENAR →", "fl.ifFalse": "JIKA SALAH →",
    "fl.branch": "Cabang {n}", "fl.addStep": "langkah", "fl.addBranch": "cabang",
    "fl.createWf": "Buat workflow",

    // ---- workflow run ----
    "wr.back": "Alur Kerja",
    "wr.actionApprove": "disetujui", "wr.actionRevise": "diminta revisi", "wr.actionReject": "ditolak",
    "wr.actionToast": "Workflow {v}.", "wr.notePrefix": "{action} via Workflow",
    "wr.approvalRequired": "Persetujuan Founder Diperlukan", "wr.viewOutput": "Lihat output",
  },

  en: {
    "nav.home": "Home", "nav.projects": "Projects", "nav.missions": "Missions", "nav.workflows": "Workflows",
    "nav.approvals": "Approvals", "nav.workforce": "AI Workforce", "nav.knowledge": "Knowledge", "nav.assets": "Assets",
    "nav.decisions": "Decisions", "nav.analytics": "Analytics", "nav.activity": "Activity", "nav.jobs": "Job Center",
    "nav.productionTools": "Production Tools", "nav.settings": "Settings",

    "layout.commandPlaceholder": "Ask or instruct MASANDI OS…  e.g. 'Buat content plan LURI SALA 7 hari'",
    "layout.execute": "Execute", "layout.running": "Running…",
    "layout.toastCmdFailed": "Command failed.",
    "layout.toastStillRunning": "Still running — check Missions shortly.",
    "layout.toastMission": "Governed Mission executed — awaiting your approval.",
    "layout.toastStatus": "Structured status assembled from live state.",
    "layout.toastCross": "CROSS_PROJECT_BLOCK — authorization required.",
    "layout.toastReceived": "Command received.",
    "layout.toastCmdFailedRetry": "Command failed. Please try again.",
    "layout.orchestratorResponse": "Orchestrator Response",
    "layout.classified": "CLASSIFIED", "layout.project": "PROJECT",
    "layout.resolution": "Resolution: {v}",
    "layout.assembledTeam": "Assembled Mission Team",
    "layout.openMissionReview": "Open Mission & Review",
    "layout.reviewAuthRequest": "Review Authorization Request",
    "layout.noDataAccessed": "No data was accessed.",
    "layout.showTest": "Show TEST/QA data", "layout.hideTest": "Hide TEST/QA data",
    "layout.testBannerLead": "TEST/QA DATA VISIBLE",
    "layout.testBannerRest": " — engineering/test artifacts are shown for debugging. Home, Analytics, CEO Brief and AI production context always ignore test data.",
    "layout.sgHealth": "Health", "layout.sgStage": "Stage", "layout.sgActiveMissions": "Active Missions",
    "layout.sgPendingApprovals": "Pending Approvals", "layout.sgCurrentCost": "Current Cost",
    "layout.sgNextMilestone": "Next Milestone", "layout.sgMainBlocker": "Main Blocker",
    "layout.sgNextAction": "Next Action",

    "gate.confirmCta": "Open Migration Gate Now",
    "gate.confirming": "Opening gate…",
    "gate.openedTitle": "P001 Migration Gate: OPEN",
    "gate.openedNote": "Import has not started automatically.",
    "gate.startCta": "Start P001 Migration",
    "gate.blockedTitle": "MIGRATION GATE BLOCKED",
    "gate.blockedNote": "Gate not opened. Outstanding blockers:",
    "gate.readiness": "Readiness",
    "gate.toastConfirm": "Founder confirmation required to open the gate.",
    "gate.toastOpened": "P001 Migration Gate opened. Import has not started.",
    "gate.toastBlocked": "Migration gate blocked — see blockers.",
    "gate.toastStaged": "Migration staged — import has not started.",

    "cmp.templates": "Command Templates",
    "cmp.suggestions": "Suggested",
    "gate.batchReady": "Batch 1 inventory prepared — no import executed.",
    "ws.tabMigration": "Migration",
    "mig.empty": "No migration batch yet. Prepare one via command: 'Siapkan Batch 1 Migrasi P001 LURI SALA — Brand & Governance Canonical'.",
    "mig.note": "Filling or approving an item does NOT run any import. Promotion to PRODUCTION only happens via batch processing + Founder approval.",
    "mig.blockers": "Migration blockers",
    "mig.provenance": "Provenance completeness",
    "mig.canonical": "Canonical input",
    "mig.source": "Source",
    "mig.sourceType": "Source type",
    "mig.sourceUrl": "Source asset URL / link",
    "mig.version": "Version",
    "mig.originalDate": "Original date (YYYY-MM-DD)",
    "mig.approvalState": "Approval state",
    "mig.lockState": "Lock state",
    "mig.supersedes": "Supersedes",
    "mig.rejectedReason": "Rejected reason",
    "mig.target": "Target collection",
    "mig.saveInput": "Save Input",
    "mig.reviewed": "Mark REVIEWED",
    "mig.approve": "Approve for Migration",
    "mig.reject": "Reject",
    "mig.rejectReason": "Reject reason (required)",
    "mig.history": "Change history",
    "mig.saved": "Migration item change saved.",
    "mig.mainBlocker": "Main blocker",
    "mig.remaining": "items still need completion before the batch can be processed",
    "mig.none": "None",
    "home.migrationReady": "Batch {n} Migration {code} ready for processing",
    "home.openMigration": "Open Migration",
    "cmp.expand": "Expand editor",
    "cmp.collapse": "Collapse",
    "cmp.pickerTitle": "Command Templates",
    "cmp.pickerHint": "Pick a template to fill the composer — it does not run automatically.",
    "cmp.useTemplate": "Use",
    "cmp.newTemplate": "New Template",
    "cmp.edit": "Edit",
    "cmp.duplicate": "Duplicate",
    "cmp.archive": "Archive",
    "cmp.favorite": "Favorite",
    "cmp.manage": "Manage Templates",
    "cmp.allCats": "All",
    "cmp.scope": "Scope",
    "cmp.scopeCompany": "COMPANY",
    "cmp.scopeProject": "PROJECT",
    "cmp.category": "Category",
    "cmp.title": "Title",
    "cmp.body": "Command body",
    "cmp.save": "Save",
    "cmp.versions": "Version history",
    "cmp.versionN": "v{n}",
    "cmp.createTitle": "Create Template",
    "cmp.editTitle": "Edit Template",
    "cmp.toastFilled": "Template loaded into composer — edit then press Run.",
    "cmp.toastSaved": "Template saved.",
    "cmp.toastDup": "Template duplicated.",
    "cmp.toastArchived": "Template archived.",
    "cmp.toastFav": "Favorite updated.",
    "cmp.needTitleBody": "Title and body are required.",

    "common.viewAll": "View all", "common.failed": "Failed", "common.actionFailed": "Action failed",
    "common.approve": "Approve", "common.revise": "Revise", "common.reject": "Reject", "common.export": "Export",
    "common.loading": "Loading…", "common.noData": "No data.",
    "common.etExecutive": "Executive", "common.etLead": "Lead", "common.etSpecialist": "Specialist", "common.etControl": "Control",
    "common.retryProviderTitle": "Retry the job to re-run the provider before approving.",

    "login.title": "Founder Access", "login.subtitle": "The governed AI-native operating system.",
    "login.password": "Password", "login.signInFailed": "Sign in failed", "login.enter": "Enter MASANDI OS",
    "login.footer": "Governed by Locks · Decisions · A0–A4 Approvals · Four-Eyes",

    "home.commandCenter": "COMMAND CENTER", "home.welcome": "Good day, Founder.",
    "home.statGoverned": "Governed Missions", "home.statGovernedSub": "lifecycle tracked",
    "home.statDecisions": "Needs Decision", "home.statDecisionsSub": "in approval center",
    "home.statLock": "Lock Compliance", "home.statLockSub": "no silent overrides",
    "home.statSpend": "AI Spend", "home.statSpendSub": "metered per run",
    "home.needsDecision": "Needs Your Decision",
    "home.noPending": "No pending approvals. The workforce is standing by within governance.",
    "home.activeMissions": "Active Missions",
    "home.noActiveMissions": "No active missions. Use the command bar below to launch one.",
    "home.requestedBy": "Requested by {name} · risk {risk} · AI rec: {rec}",
    "home.workforce": "AI Workforce", "home.inspect": "Inspect", "home.persistentEmployees": "persistent AI employees",
    "home.portfolio": "Project Portfolio",
    "home.recentActivity": "Recent Activity", "home.noActivity": "No activity yet.",

    "projects.label": "PROJECT PORTFOLIO", "projects.title": "Projects",
    "projects.subtitle": "Multi-project from day one. Every project is fully isolated.",
    "projects.new": "New Project", "projects.createTitle": "Create Project",
    "projects.phCode": "Project code (e.g. P002)", "projects.phName": "Project name",
    "projects.phIndustry": "Industry", "projects.phObjective": "Primary objective",
    "projects.createSubmit": "Create isolated project",
    "projects.codeNameRequired": "Code and name required",
    "projects.created": "Project {code} created — isolated from all other projects.",
    "projects.health": "Health: {v}",

    "ws.back": "Projects",
    "ws.requestNote": "Founder requested change to {title}",
    "ws.requestToast": "{result} — no entity overwritten. A4 override approval created.",
    "ws.tabOverview": "Overview", "ws.tabMissions": "Missions", "ws.tabTasks": "Tasks", "ws.tabDecisions": "Decisions",
    "ws.tabAssets": "Assets", "ws.tabGovernance": "Governance", "ws.tabActivity": "Activity",
    "ws.cardActiveMissions": "Active Missions", "ws.cardPendingApprovals": "Pending Approvals",
    "ws.cardCurrentCost": "Current Cost", "ws.cardMainBlocker": "Main Blocker",
    "ws.cardNextMilestone": "Next Milestone", "ws.cardNextAction": "Recommended Next Action",
    "ws.overrides": "Project Overrides (P-specific only)",
    "ws.noMissions": "No missions yet.", "ws.noTasks": "No production tasks for this project yet.",
    "ws.byMaker": "by {v}",
    "ws.govText1": "Frozen / Brand / Legal / Compliance locks cannot be edited. The action becomes",
    "ws.govText2": "→ impact analysis → explicit Founder override.",
    "ws.requestChange": "Request Change",

    "missions.label": "GOVERNED EXECUTION", "missions.title": "Missions",
    "missions.subtitle": "Every mission is assembled, executed, reviewed (Four-Eyes) and Founder-approved. Launch via the command bar below.",
    "missions.empty": "No missions yet. Try:",

    "md.back": "Missions",
    "md.actionApprove": "approved", "md.actionRevise": "revision requested", "md.actionReject": "rejected",
    "md.actionToast": "Mission {v}.",
    "md.notePrefix": "{action} via Mission view",
    "md.exportEmpty": "(no deliverable)", "md.exported": "Deliverable exported.",
    "md.creatingProd": "Production mission is being generated…", "md.prodCreated": "Production mission created.",
    "md.prodFailed": "Production mission failed to generate.",
    "md.successCriteria": "Success criteria:",
    "md.approvalRequired": "Founder Approval Required",
    "md.fallbackWarning": "GOVERNED FALLBACK draft — provider was unavailable. Approval is blocked until the job is retried.",
    "md.risk": "Risk", "md.cost": "Cost", "md.reversibility": "Reversibility", "md.aiRec": "AI Rec",
    "md.requestRevision": "Request Revision",
    "md.founderApproved": "Founder-approved",
    "md.createProduction": "Create Production Mission", "md.approveFirstTitle": "Approve this mission first",
    "md.finalDeliverable": "Compiled Final Deliverable",
    "md.noDeliverable": "No deliverable compiled yet.",
    "md.strategy": "STRATEGY SUMMARY", "md.audience": "TARGET AUDIENCE",
    "md.objectives": "CONTENT OBJECTIVES", "md.pillars": "CONTENT PILLARS", "md.channelMix": "PLATFORM / CHANNEL MIX",
    "md.calendar": "{days}-DAY CONTENT CALENDAR",
    "md.thDay": "Day", "md.thTopic": "Topic", "md.thFormat": "Format", "md.thHook": "Hook",
    "md.thKeyMessage": "Key Message", "md.thCta": "CTA", "md.thProdNotes": "Production Notes", "md.thRole": "Role",
    "md.complianceNotes": "BRAND / COMPLIANCE REVIEW NOTES",
    "md.generatedAssets": "Generated Assets · real tool output",
    "md.assetBy": "by {a} · {m}",
    "md.assetToolLine": "tool {t} · {p} · cost ${c}",
    "md.draftNote": "Assets start as DRAFT and require Founder approval before release. Provenance (agent · tool · provider · model · cost) recorded on every asset.",
    "md.toolRuns": "Tool Runs · governed execution",
    "md.toolRunLine": "agent {a} · cost ${c}",
    "md.team": "Mission Team · selected by skill data",
    "md.tasks": "Task Execution & Outputs",
    "md.reviews": "Review Results (Four-Eyes)", "md.noReviews": "No review tasks recorded.",
    "md.finalAsset": "Final Asset / Result",
    "md.costAudit": "Cost & Audit · State Transitions",
    "md.totalCost": "Total mission cost:",

    "ap.label": "GOVERNANCE · A0–A4", "ap.title": "Approval Center",
    "ap.subtitle": "Founder authority. A4 items require explicit override confirmation.",
    "ap.notePrefix": "{action} via Approval Center",
    "ap.recorded": "{action} recorded{suffix}.", "ap.overrideSuffix": " — override confirmed",
    "ap.revokeToast": "Access {from} → {to} revoked — future references blocked again.",
    "ap.revokeFailed": "Revoke failed",
    "ap.activeGrants": "Active Cross-Project Access",
    "ap.grantsDesc": "Granted read access to another project's approved knowledge. Revoke to block future cross-project references immediately.",
    "ap.defaultReason": "Cross-project knowledge access",
    "ap.expirySet": "Expires {d}", "ap.noExpiry": "No expiry set",
    "ap.revoke": "Revoke", "ap.history": "Cross-Project Grant History",
    "ap.tabAll": "ALL", "ap.empty": "No approvals in this view.",
    "ap.requestedBy": "Requested by {v}",
    "ap.fallbackWarning": "GOVERNED FALLBACK draft — the provider was unavailable during execution. Approval is blocked until you retry the job to re-run the provider.",
    "ap.risk": "Risk", "ap.cost": "Cost", "ap.reversible": "Reversible", "ap.aiRec": "AI Rec",
    "ap.expiryPlaceholder": "Expiry days (optional)",
    "ap.confirmOverride": "Confirm Override", "ap.openMission": "Open Mission",

    "jobs.label": "UNIFIED RUNTIME · COMMAND · MISSION · WORKFLOW · TASK", "jobs.title": "Job Center",
    "jobs.subtitle": "Read-only execution monitor. Governance cannot be bypassed here — drill down to act.",
    "jobs.refresh": "Refresh",
    "jobs.attention": "{n} job(s) require Founder attention.",
    "jobs.empty": "No jobs in this view.",
    "jobs.cancelled": "Job cancelled.", "jobs.retryLaunched": "Retry launched.",
    "jobs.attentionTitle": "Founder attention required",
    "jobs.cancel": "Cancel", "jobs.retries": "retries {n}",

    "pt.label": "SPEC-06 · GOVERNED PRODUCTION TOOL LAYER", "pt.title": "Production Tools",
    "pt.subtitle": "Employees own jobs · tools execute · MASANDI OS controls routing, permissions, budgets, approvals and audit. Provider secrets are server-side only.",
    "pt.noRecords": "No records.",
    "pt.tabRegistry": "Registry", "pt.tabProviders": "Providers", "pt.tabCapabilities": "Capabilities",
    "pt.tabPermissions": "Employee Permissions", "pt.tabBudgets": "Budgets", "pt.tabHealth": "Health", "pt.tabRuns": "Runs",
    "pt.capabilities": "capabilities: {v}",
    "pt.budgetLine": "{code} — run ${a} · task ${b} · mission ${c} · daily ${d} · monthly ${e}",

    "an.label": "COST & PERFORMANCE", "an.title": "Analytics",
    "an.subtitle": "Cost tracked by company, project, mission, employee and model.",
    "an.statSpend": "Total AI Spend", "an.statRuns": "Total Runs", "an.statMissions": "Missions", "an.statWorkforce": "Workforce Active",
    "an.accuracy": "COST ACCURACY", "an.meteredRuns": "Provider-metered runs:", "an.estimatedRuns": "Estimated runs:",
    "an.tokensIn": "in", "an.tokensOut": "out",
    "an.accuracyNote": "Provider-metered figures use real token usage reported by the model; estimated runs predate metered accounting or lack a usage report.",
    "an.byProject": "Cost by Project", "an.byModel": "Cost by Model", "an.byEmployee": "Cost by Employee",
    "an.noCost": "No cost data yet.",

    "settings.title": "Settings",
    "settings.tvTitle": "TEST / QA Data Visibility",
    "settings.tvToggleLabel": "Show TEST / QA data across listing screens",
    "settings.tvDesc": "Master preference (persists across sessions). Default OFF. Even when ON, Home, Analytics, AI CEO Brief, Portfolio health, Knowledge retrieval and AI production context always exclude test data — this only affects listing/debug visibility.",
    "settings.logoStatus": "Logo status:", "settings.logoNote": "replaceable without redesigning the application.",
    "settings.brandHierarchy": "Brand Hierarchy", "settings.projectsLine": "Projects",
    "settings.founderAccount": "Founder Account", "settings.name": "Name", "settings.role": "Role",
    "settings.invariants": "Architecture Invariants (permanent)",
    "settings.langTitle": "Interface Language",
    "settings.langDesc": "Language for all UI labels, buttons and messages. System field/status names stay in English because they are data values.",
    "settings.langId": "Indonesia", "settings.langEn": "English",

    "wf.title": "AI Workforce",
    "wf.count": "{n} persistent AI employees · idle employees incur zero inference cost.",
    "wf.grid": "Grid", "wf.org": "Organization",
    "wf.searchPh": "Search name, role or code…", "wf.allDepts": "All departments",

    "org.hint": "Drag to pan · Ctrl+scroll to zoom · minimap to jump · click node to open",
    "org.founderSub": "Human authority",
    "org.founderSubFull": "Human authority · GO / HOLD / KILL · Override",

    "ag.back": "Workforce", "ag.testFailed": "Test run failed.",
    "ag.reportsTo": "· reports to {name} ({pos})", "ag.performance": "Performance: {v}",
    "ag.runTest": "Run Test",
    "ag.tabOverview": "Overview", "ag.tabJobdesk": "Jobdesk", "ag.tabSkills": "Skills", "ag.tabSop": "SOP",
    "ag.tabAuthority": "Authority", "ag.tabTools": "Tools", "ag.tabKpis": "KPIs", "ag.tabRuns": "Runs",
    "ag.missionStatement": "Mission Statement", "ag.specTags": "Specialization Tags",
    "ag.modelCapability": "Model Capability", "ag.knowledgeScope": "Knowledge Scope",
    "ag.coreResp": "Core Responsibilities", "ag.collabRules": "Collaboration Rules", "ag.failureConds": "Failure Conditions",
    "ag.skillMatrix": "Skill Matrix (1 Awareness → 5 Expert)", "ag.sop": "Standard Operating Method",
    "ag.autonomy": "Autonomy Level", "ag.riskCeiling": "Risk Ceiling",
    "ag.allowed": "Allowed Actions", "ag.forbidden": "Forbidden Actions",
    "ag.approvalRules": "Approval Rules", "ag.escalationRules": "Escalation Rules",
    "ag.toolPerms": "Tool Permissions", "ag.kpis": "Key Performance Indicators",
    "ag.aiRuns": "AI Runs (metered execution history)",
    "ag.noRuns": "No runs yet — idle employees incur zero inference cost.",
    "ag.testMode": "Test Mode · {name}",
    "ag.testContext": "Project P001 context loaded · external actions disabled · model {m}.",
    "ag.instructPh": "Instruct {name}…", "ag.run": "Run", "ag.contextUsed": "Context used",

    "act.label": "AUDIT TRAIL · WHO · WHAT · WHY", "act.title": "Activity",
    "act.subtitle": "Every meaningful operation is reconstructable for full auditability.",
    "act.empty": "No activity recorded yet.",
    "as.title": "Assets", "as.subtitle": "Asset → Version → Approval → Lock. Old versions remain accessible.",
    "as.empty": "No assets yet.", "as.versions": "{n} version(s)",
    "dec.label": "DECISION LOG", "dec.title": "Decisions",
    "dec.subtitle": "Every material decision is recorded with context, options, rationale and maker.",
    "dec.rationale": "Rationale:", "dec.byMaker": "by {v}",
    "kn.title": "Knowledge",
    "kn.subtitle": "Durable, approved knowledge — chat history never becomes company truth automatically.",
    "kn.empty": "No knowledge items yet.", "kn.curatedBy": "curated by {v}",

    "fl.label": "REUSABLE WORKFLOW ENGINE", "fl.title": "Workflows",
    "fl.subtitle": "Multi-step governed pipelines with CONDITION branches and PARALLEL forks. Each step routes to a skill-matched employee.",
    "fl.new": "New Workflow", "fl.steps": "{n} steps", "fl.runWf": "Run Workflow",
    "fl.recentRuns": "Recent Runs", "fl.noRuns": "No workflow runs yet.",
    "fl.executed": "Workflow executed.", "fl.runFailed": "Run failed",
    "fl.titleRequired": "Title required", "fl.stepNeedsName": "Every step needs a name",
    "fl.stepNeedsSkill": "Step '{name}' needs a skill",
    "fl.created": "Custom workflow created.", "fl.saveFailed": "Save failed",
    "fl.runDialogTitle": "Run · {t}", "fl.objectivePh": "Objective", "fl.executeSteps": "Execute steps",
    "fl.builder": "Workflow Builder", "fl.wfTitlePh": "Workflow title", "fl.wfDescPh": "Short description",
    "fl.stepsLabel": "Steps (run in order)",
    "fl.stepNamePh": "Step name", "fl.requiredSkillPh": "Required skill…",
    "fl.ifTrue": "IF TRUE →", "fl.ifFalse": "IF FALSE →",
    "fl.branch": "Branch {n}", "fl.addStep": "step", "fl.addBranch": "branch",
    "fl.createWf": "Create workflow",

    "wr.back": "Workflows",
    "wr.actionApprove": "approved", "wr.actionRevise": "revision requested", "wr.actionReject": "rejected",
    "wr.actionToast": "Workflow {v}.", "wr.notePrefix": "{action} via Workflow",
    "wr.approvalRequired": "Founder Approval Required", "wr.viewOutput": "View output",
  },
};
